import { render, staticRenderFns } from "./destination.vue?vue&type=template&id=b9ad393e&scoped=true"
import script from "./destination.vue?vue&type=script&lang=js"
export * from "./destination.vue?vue&type=script&lang=js"
import style0 from "./destination.vue?vue&type=style&index=0&id=b9ad393e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ad393e",
  null
  
)

export default component.exports